export enum TemplateMail {     
     CompteAjoute=1,
     MembreFamilleAjoute=2,
     InscriptionCours=3,
     AnnulationCours=4,
     ForgotPassword=5,     
     ChangePassword=6,     
     CommandeValidee=7,
     CommandeAnnulee=8,
     ListeAttenteCours=9,
     Message=10,
     InscriptionNewsletter=11,
     DesinscriptionNewsLetter=12
}